import { configApi } from '../http-client.js'

const BASE_URL = '/api/encryptionkeys'

/**
 * Get all available encryption types
 * @returns {Promise<Array>} Array of encryption type objects
 */
export const getEncryptionTypes = () => {
	return configApi.get(`${BASE_URL}/Types`).then(response => response.data.encryptionTypes)
}

/**
 * Get all encryption keys (metadata only)
 * @returns {Promise<Array>} Array of encryption key metadata
 */
export const getEncryptionKeys = () => {
	return configApi.get(BASE_URL).then(response => response.data.encryptionKeys || [])
}

/**
 * Get a single encryption key by ID (metadata only)
 * @param {number} encryptionKeyId - The key ID
 * @returns {Promise<Object>} Encryption key metadata
 */
export const getEncryptionKey = encryptionKeyId => {
	return configApi.get(`${BASE_URL}/${encryptionKeyId}`).then(response => response.data)
}

/**
 * Create or update an encryption key
 * @param {Object} request - The upsert request
 * @returns {Promise<Object>} Response with newEncryptionKeyId or rowsAffected
 */
export const upsertEncryptionKey = request => {
	return configApi.post(`${BASE_URL}/Upsert`, request).then(response => response.data)
}

/**
 * Test encryption/decryption
 * @param {Object} request - The test request
 * @returns {Promise<Object>} Test result with success, encryptedText, decryptedText, error
 */
export const testEncryption = request => {
	return configApi.post(`${BASE_URL}/Test`, request).then(response => response.data)
}

/**
 * Delete an encryption key
 * @param {number} encryptionKeyId - The key ID to delete
 * @returns {Promise<Object>} Delete result
 */
export const deleteEncryptionKey = encryptionKeyId => {
	return configApi.delete(`${BASE_URL}/${encryptionKeyId}`).then(response => response.data)
}

export default {
	getEncryptionTypes,
	getEncryptionKeys,
	getEncryptionKey,
	upsertEncryptionKey,
	testEncryption,
	deleteEncryptionKey
}
